import Cookies from 'js-cookie';
export const sessionStoregeItemAndCookieName = 'spf_paymentdata';
export type CookieData = {
    href: string;
    paymentRef: string;
};

export function onCancelClick(paymentref: string) {
    // @ts-ignore
    $.ajax({
        url: '/api/payment/CancelPayment/',
        data: JSON.stringify({ paymentRef: paymentref }),
        contentType: 'application/json',
        type: 'DELETE',
        success: function (data) {
            Cookies.remove(sessionStoregeItemAndCookieName);
            sessionStorage.removeItem(sessionStoregeItemAndCookieName);
            window.location.href = '/';
        },
    });
}

export function onPaymentAttemptStarted() {
    hideCancelButton();
}

function hideCancelButton() {
    const cancelButton = document.querySelector('#btn-cancel-payment');
    if (cancelButton) {
        cancelButton.classList.add('hidden')
    }
}

export function onPaymentCompletedHandler(onPaidEvents) {
    const formBox = document.querySelector('.form-box');
    formBox.querySelector('legend').classList.add('hidden');
    formBox.querySelectorAll('.row').forEach((row) => {
        row.classList.add('hidden');
    });
    formBox.querySelectorAll('.form-box__highlight').forEach((highlight) => {
        highlight.classList.add('hidden');
    });
    hideCancelButton();
    document
        .getElementById('checkout-container')
        .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });

    sessionStorage.removeItem(sessionStoregeItemAndCookieName);

    const paymentData = {
        RedirectUrl: onPaidEvents.redirectUrl,
        SwedbankPaymentId: onPaidEvents.paymentOrder.id,
    };
    const data = {
        PaymentData: paymentData
    };
    //@ts-ignore
    $.ajax({
        url: '/api/payment/CheckPaymentStatus/',
        data: JSON.stringify(data),
        contentType: 'application/json',
        type: 'POST',
        success: function (data) {
            window.location = data;
        },
        error: function (ex) {
            console.error(ex);
        },
    });
}

document.addEventListener('DOMContentLoaded', function (e) {
    const cancelButton = document.querySelector('#btn-cancel-payment');
    const data = Cookies.get(sessionStoregeItemAndCookieName);
    if (data) {
        const formRows = document.querySelectorAll('#register .row');
        const formBoxes = document.querySelectorAll('#register .form-box__highlight');
        const payButton = document.querySelector('#pay-form');
        payButton.classList.add('hidden');
        formRows.forEach((row) => {
            row.classList.add('hidden');
        });
        formBoxes.forEach((box) => {
            box.classList.add('hidden');
        });

        var existingIframe = document.querySelector('#checkout-container iframe');
        if (existingIframe == null) {
            const cookieData = JSON.parse(data) as CookieData;

            if (cancelButton && cookieData?.paymentRef) {
                cancelButton.addEventListener('click', function () {
                    onCancelClick(cookieData.paymentRef);
                });
                cancelButton.classList.remove('hidden');
            }

            var script = document.createElement('script');
            script.setAttribute('src', cookieData.href);

            script.onload = function () {
                // When the 'view-checkout' script is loaded, we can initialize the
                // Payment Menu inside 'checkout-container'.
                // @ts-ignore
                payex.hostedView
                    .paymentMenu({
                        container: 'checkout-container',
                        culture: 'sv-SE',
                        onPaid: onPaymentCompletedHandler,
                        onAborted: (_) => {
                            Cookies.remove(sessionStoregeItemAndCookieName);
                            sessionStorage.removeItem(sessionStoregeItemAndCookieName);
                            window.location.href = '/';
                        }
                    })
                    .open();
            };
            var head = document.getElementsByTagName('head')[0];
            head.appendChild(script);
        }
    } else {
        sessionStorage.removeItem(sessionStoregeItemAndCookieName);
    }
});